import * as React from 'react';
import { IDocument, ISeedProduct } from 'src/infrastructure/interfaces';
import TypeSeedIcons from './TypeSeedIcons';
import TypeSeedTable from './TypeSeedTable';
import TypeSeedBarChart from './TypeSeedBarChart';
import { SeedCategory } from 'src/infrastructure/enums';
import './TypeSeedGraphics.css';

export interface ITypeSeedGraphics {
  product: ISeedProduct;
  document?: IDocument;
}

export default class TypeSeedGraphics extends React.Component<ITypeSeedGraphics> {
  tableCategories: object;
  barCategories: object;
  categoryId: string|number;

  constructor(props: any) {
    super(props);

    this.categoryId = this.props.product.category.id;
    
    this.tableCategories = {
      [SeedCategory.Canola]: SeedCategory.Canola,
    };
    this.barCategories = {
      [SeedCategory.Alfalfa]: SeedCategory.Alfalfa,
      [SeedCategory.Corn]: SeedCategory.Corn,
      [SeedCategory.Sunflower]: SeedCategory.Sunflower,
      [SeedCategory.SoftRedWinterWheat]: SeedCategory.SoftRedWinterWheat,
      [SeedCategory.Silage]: SeedCategory.Silage,
      [SeedCategory.ForageSorghum]: SeedCategory.ForageSorghum,
      [SeedCategory.GrainSorghum]: SeedCategory.GrainSorghum,
      [SeedCategory.SudangrassSorghum]: SeedCategory.SudangrassSorghum,
      [SeedCategory.SoybeansOver3_5RM]: SeedCategory.SoybeansOver3_5RM,
      [SeedCategory.SoybeansUnder3_5RM]: SeedCategory.SoybeansUnder3_5RM,
      [SeedCategory.HardRedSpringWheat]: SeedCategory.HardRedSpringWheat,
      [SeedCategory.HardRedWinterWheat]: SeedCategory.HardRedWinterWheat,
      [SeedCategory.SoftWhiteWinterWheat]: SeedCategory.SoftWhiteWinterWheat,
    };
  }

  

  render() {
    // const docType = this.props.document ? this.props.document.type : "";

    return (
      <div className="seed-graphics">
        {this.tableCategories[this.categoryId] &&
          <TypeSeedTable product={this.props.product} document={this.props.document}/>}
        {this.barCategories[this.categoryId] &&
          <TypeSeedBarChart product={this.props.product} document={this.props.document}/>}
        <TypeSeedIcons product={this.props.product} document={this.props.document}/>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/Products/components/TypeSeedGraphics.tsx